import { useDispatch, useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useState } from "react";
import { toast } from "react-toastify";
import { viewFavourite } from "./api";
import {
  useGetFavouriteCategoryListDataQuery,
  useUpdateFavouriteCategoryTableHeadDataMutation,
} from "../../../store/queries/User";
import { IconText } from "@wac-ui-dashboard/wac_component_library";

const useFavouriteCategory = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const { showEditModal } = useSelector((state) => state.global);
  const [favouriteCategoryState, setFvouriteCategoryState] = useState({
    currentPageSize: 10,
    currentPage: 1,
    search: "",
    sortBy: "",
    sortOrder: "desc",
    itemId: "",
    showModal: false,
    itemData: "",
    imageFile: "",
    imageAliasFile: "",
    isEdit: false,
    showImageModal: false,
    imageData: "",
  });
  const {
    data: favouriteCategoryList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetFavouriteCategoryListDataQuery({
    page_size: favouriteCategoryState?.currentPageSize,
    page: favouriteCategoryState?.currentPage,
    search: favouriteCategoryState?.search,
    sort_by: favouriteCategoryState?.sortBy,
    sort_order: favouriteCategoryState?.sortOrder,
  });
  const [updateFavouriteCategoryTableHeadData] =
    useUpdateFavouriteCategoryTableHeadDataMutation();
  const handleSearch = (e) => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      search: e?.target?.value,
      currentPage: 1,
    }));
  };
  const handleClearClick = () => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      search: "",
      currentPage: 1,
    }));
  };
  const handleSort = (label) => {
    if (favouriteCategoryState?.sortBy === label) {
      setFvouriteCategoryState((prev) => ({
        ...prev,
        currentPage: 1,
        sortOrder: prev.sortOrder === "asc" ? "desc" : "asc",
      }));
    } else {
      setFvouriteCategoryState((prev) => ({
        ...prev,
        currentPage: 1,
        sortBy: label,
        sortOrder: "asc",
      }));
    }
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };
  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data?.[field]}</p>,
      image: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.image)}
            />
          </div>
        );
      },
      alias_image: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.alias_image)}
            />
          </div>
        );
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleEditAction = (id) => {
    const itemId = id?.[0];
    viewFavourite(itemId).then((res) => {
      if (res?.data?.status_code === 200) {
        setFvouriteCategoryState((prev) => ({
          ...prev,
          itemId: itemId,
          itemData: res?.data?.data,
          showModal: true,
          imageFile: res?.data?.data?.image_url ?? "",
          imageAliasFile: res?.data?.data?.alias_image_url ?? "",
          isEdit: true,
        }));
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  const handlePagination = (page) => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };
  const handlePageSize = ({ value: page_size }) => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      currentPageSize: page_size,
      currentPage: 1,
    }));
  };
  const handleModal = () => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      imageData: "",
      showModal: !favouriteCategoryState?.showModal,
      itemId: "",
      imageFile: "",
      imageAliasFile: "",
      isEdit: false,
      itemData:""
    }));
  };
  const closeImageModal = () => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      showImageModal: false,
      imageData: "",
    }));
  };
  const handleViewImage = (data) => {
    setFvouriteCategoryState((prev) => ({
      ...prev,
      showImageModal: true,
      imageData: data ?? "",
    }));
  };
  return {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    favouriteCategoryList,
    favouriteCategoryState,
    closeImageModal,
    setFvouriteCategoryState,
    handleEditAction,
    handleModal,
    setFvouriteCategoryState,
    updateFavouriteCategoryTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useFavouriteCategory;
